import { render, staticRenderFns } from "./Order_other_detail.vue?vue&type=template&id=bd9ce3ae&scoped=true&"
import script from "./Order_other_detail.vue?vue&type=script&lang=js&"
export * from "./Order_other_detail.vue?vue&type=script&lang=js&"
import style0 from "./Order_other_detail.vue?vue&type=style&index=0&id=bd9ce3ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9ce3ae",
  null
  
)

export default component.exports